// src/pages/SubscribeSuccess.js
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Purchases as PurchasesWeb } from "@revenuecat/purchases-js";
import { useSubscription } from "../contexts/SubscriptionContext";
import apiClient from "../utils/apiClient";
import { toast } from "react-toastify";

const webKey = process.env.REACT_APP_REVENUECAT_WEB_API_KEY;

export default function SubscribeSuccess() {
  const { isSubscribed, isRcReady, setIsSubscribed } = useSubscription();
  const navigate = useNavigate();
  const [status, setStatus] = useState("loading"); 
  // └─ 'loading' | 'success' | 'pending' | 'error'

  useEffect(() => {
    // Don’t do anything until useRevenueCat has finished configuring the Web SDK
    if (!isRcReady) {
      return;
    }

    // Now that isRcReady === true, we can safely fetch the latest customerInfo
    (async () => {
      try {
        // Double-check: if there’s no rc_app_user_id in localStorage, bail out
        const savedRcId = localStorage.getItem("rc_app_user_id");
        if (!savedRcId) {
          // Nobody ever went through paywall flow
          navigate("/subscribe", { replace: true });
          return;
        }

        // At this point, PurchasesWeb.configure(...) has already run in useRevenueCat,
        // so getCustomerInfo() will not be “Not configured.”
        const customerInfo = await PurchasesWeb.getSharedInstance().getCustomerInfo();
        //toast.info("CustomerInfo fetched: " + JSON.stringify(customerInfo));

        const isActive = !!customerInfo.entitlements?.active?.["sous_premium"];
        setIsSubscribed(isActive);
        //toast.info("isSubscribed: " + isActive);

        if (isActive) {

          // Let your backend know, if needed
          console.log(`updating user: ${savedRcId} with subcribe status: ${isActive}`);
          await apiClient.post("/subscriptions/register", { customerInfo }).catch((e) => console.error('register failed', e));;

          setStatus("success");
          setTimeout(() => {
            navigate("/", { replace: true });
          }, 1500);
        } else {
          setStatus("pending");
        }
      } catch (err) {
        console.error("Error verifying subscription:", err);
        setStatus("error");
      }
    })();
  }, [isRcReady, navigate, setIsSubscribed]);

  if (!isRcReady) {
    // You can either return null or show a spinner until isRcReady flips true
    return <p className="text-center py-16">Verifying subscription…</p>;
  }

  if (status === "loading") {
    return <p className="text-center py-16">Verifying subscription…</p>;
  }
  if (status === "success") {
    return <p className="text-center py-16 text-green-600">Thank you for subscribing! Redirecting…</p>;
  }
  if (status === "pending") {
    return (
      <div className="text-center py-16">
        <p>Your subscription is pending activation. It may take a few moments to process.</p>
        <button onClick={() => navigate("/", { replace: true })} className="mt-4 underline">
          Go to Home
        </button>
      </div>
    );
  }
  // status === "error"
  return (
    <div className="text-center py-16">
      <p className="text-red-500">There was an error verifying your subscription. Please contact support.</p>
      <button onClick={() => navigate("/subscribe", { replace: true })} className="mt-4 underline">
        Try Again
      </button>
    </div>
  );
}
